<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-30 16:23:02
 * @LastEditors: Francis
 * @LastEditTime: 2022-08-02 15:01:54
-->
<template>
  <div class="parts">
    <div class="head">
      <p class="title">配件</p>
      <van-tabs
        type="line"
        v-model="active"
        background="#44b1f9"
        color="#fff"
        title-active-color="#fff"
        title-inactive-color="#fff"
        @click="onClick"
      >
        <van-tab title="未核销"></van-tab>
        <van-tab title="已核销"></van-tab>
      </van-tabs>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="table_view"
      >
        <div
          class="table_cell"
          v-for="(item, index) in tableList"
          :key="index"
          
        >
          <div class="head_info">
            <div class="type"><p>配件类型</p></div>
            <p class="sub-title">{{item.fittingCategory}}</p>
            <div class="state1" v-if="active === 0" @click="onClickCell(item)">审核</div>
            <div class="state2" v-if="active === 1">已核销</div>
          </div>
          <p class="num">数量：<span>{{item.applyNum}}</span></p>
          <p class="starTime">申请时间：<span>{{item.applyTime}}</span></p>
          <p v-if="active === 1" class="starTime">
            核销时间：<span>{{item.verificationTime}}</span>
          </p>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-overlay :show="show" z-index="999999999999">
      <div class="wrapper">
        <div class="block">
          <img
            src="../../../assets/audit/blackxx.png"
            class="icon"
            @click="onClickIcon"
          />
          <p class="title">审核核销申请</p>
          <p class="sub_title">
            &nbsp;&nbsp;&nbsp;配件类型：<span>{{detailFit.fittingCategory}}</span>
          </p>
          <p class="sub_title">&nbsp;&nbsp;&nbsp;数量：<span>{{detailFit.applyNum}}</span></p>
          <div class="img_arr" v-if="detailFit.pics">
            <van-image
              v-for="item in detailFit.pics" 
              :key="item.id"
              width="52"
              height="52"
              fit="contain"
              :src="item.url"
              class="imageItem"
            />
            <!-- <img class="img" src="../../../assets/audit/1111111.png" v-for="item in 3" :key="item" /> -->
          </div>
          <div class="reject" @click="onClickState(1)">驳回</div>
          <div class="pass" @click="onClickState(2)">通过</div>
        </div>
      </div>
    </van-overlay>
    <Footer :page="1" :mineActive="1"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { verificationList, getVerificationInfo, verifyVerfication } from "@/utils/network/interface"
export default {
  name: "",
  components: {
    Footer,
    Header,
  },
  props: {},
  data() {
    return {
      show: false,
      active: 0,
      tableList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      detailFit:{}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    onClickCell(item) {
      if (this.active != 0) return;
      getVerificationInfo({id: item.id}).then((res) =>{
        console.log(res)
        if(res.code == 200){
          this.detailFit = res.data
          this.show = true;
        }
      })
    },
    onClick(index) {
      // console.log(index);
      this.tableList =[]
      this.getData()
    },
    onLoad() {
      setTimeout(() => {
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { pageSize, pageNum };
        let params = {
          vType: this.active +1,
          ...obj,
        };
        verificationList(params)
          .then((res) => {
            if (res.code === 200) {
              if (!res.rows)
                return (
                  (this.finished = true),
                  (this.loading = false),
                  (this.page.pageNum = 1),
                  (this.tableList = [])
                );
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 500);
    
    },
    getData() {
      let obj = { pageSize: 10, pageNum: 1 };
      let params = {
        vType: this.active +1,
        ...obj,
      };
      verificationList(params)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            if (!res.rows) {
              this.finished = true;
              this.loading = false;
              this.pageInfo.pageNum = 1;
              this.tableList = [];
            } else {
              this.finished =  res.rows.length< 11
              this.tableList = res.rows;
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
            }
          } else {
            this.tableList = [];
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getData();
      this.pageInfo.pageNum++
    },
    onClickIcon() {
      this.detailFit = {}
      this.show = false;
    },
    onClickState(type) {
      verifyVerfication({id:this.detailFit.id,type:type}).then(res =>{
        if(res.code == 200){
          this.$toast({
            type:"success",
            message:`${type == 1 ?'驳回':'通过'}成功`
          })
          this.show = false;
          this.getData()
        }
      })
      
    },
  },
};
</script>

<style lang="less" scoped>
.parts {
  min-height: 100vh;
  .head {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 104px;
    background: #44b1f9;
    padding-top: 36px;
    .title {
      font-size: 16px;
      text-align: center;
      line-height: 25px;
      height: 25px;
      color: #fff;
    }
  }
  .table_view {
    width: 100%;
    margin-top: 114px;
    min-height: calc( 100vh - 184px);
    .table_cell {
      width: 94%;
      min-height: 107px;
      background-color: white;
      border-radius: 5px;
      margin: 0 auto;
      margin-top: 10px;
      padding-bottom: 13px;
      .head_info {
        height: 42px;
        width: 100%;
        background: linear-gradient(
          79deg,
          rgba(68, 177, 249, 0.12) 0%,
          rgba(255, 255, 255, 0.12) 100%
        );
        border-radius: 5px 5px 0px 0px;
        padding-left: 13px;
        padding-top: 14px;
        padding-right: 13px;
        // display: flex;
        .type {
          width: 58px;
          height: 15px;
          background-color: rgba(255, 0, 0, 0.15);
          font-size: 13px;
          text-align: center;
          float: left;
          p {
            color: red;
            line-height: 15px;
            font-size: 13px;
          }
        }
        .sub-title {
          margin-left: 5px;
          float: left;
        }
        // .state1 {
        //   width: 54px;
        //   height: 23px;
        //   background: #44b1f9;
        //   border-radius: 5px;
        //   color: white;
        //   margin-left: 130px;
        //   margin-top: -5px;
        //   line-height: 23px;
        //   text-align: center;
        // }
        // .state2 {
        //   width: 67px;
        //   height: 23px;
        //   background: rgba(153, 153, 153, 0.15);
        //   border-radius: 5px;
        //   color: rgba(153, 153, 153, 1);
        //   margin-left: 120px;
        //   margin-top: -5px;
        //   line-height: 23px;
        //   text-align: center;
        //   border: 1px solid #999999;
        // }
        .state1 {
          min-width: 54px;
          height: 23px;
          background: #44b1f9;
          border-radius: 5px;
          color: white;
          line-height: 23px;
          text-align: center;
          padding:0 10px;
          font-size: 12px;
          float: right;
          margin-top: -4px;
        }
        .state2 {
          min-width: 54px;
          height: 23px;
          padding:0 10px;
          background: rgba(153, 153, 153, 0.15);
          border-radius: 5px;
          color: rgba(153, 153, 153, 1);
          margin-top: -4px;
          line-height: 23px;
          text-align: center;
          border: 1px solid #999999;
          font-size: 12px;
          float: right;
        }
      }
      .num {
        margin-left: 13px;
        margin-top: 11px;
        color: #5e5e5ea9;
        span {
          color: #44b1f9;
        }
      }
      .starTime {
        margin-left: 13px;
        margin-top: 11px;
        color: #5e5e5ea9;
        span {
          color: #5e5e5e;
        }
      }
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999999;
    .block {
      width: 269px;
      min-height: 269px;
      padding-bottom: 20px;
      background: url("../../../assets/audit/hxBg.png") 0 0 no-repeat;
      background-size: 269px 60px;
      background-color: white;
      border-radius: 10px;
      .icon {
        width: 15px;
        height: 15px;
        float: right;
        margin-right: 16px;
        margin-top: 21px;
      }
      .title {
        font-size: 16px;
        color: black;
        text-align: center;
        margin-top: 45px;
        font-weight: 700;
        margin-bottom: 29px;
      }
      .sub_title {
        margin: 0 auto;
        margin-bottom: 13px;
        border-left: 2px solid #44b1f9;
        font-size: 13px;
        color: black;
        width: 80%;
        span {
          color: #5e5e5e;
        }
      }
      .img_arr {
        // display: flex;
        width: 80%;
        margin: 0 auto;
        .imageItem {
          margin-right: 9px;
          margin-bottom: 9px;
        }
      }
      .reject {
        width: 87px;
        height: 28px;
        border: 1px solid #999999;
        border-radius: 5px;
        color: #999999;
        text-align: center;
        line-height: 28px;
        float: left;
        margin-top: 20px;
        margin-left: 40px;
      }
      .pass {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        float: left;
        margin-top: 20px;
        margin-left: 20px;
      }
    }
  }
}
</style>
